import { Field, Form, FormikProps } from 'formik';
import { FormikTextInput } from '@forms/Components/TextInput';
import { RailBillingForm } from './types';

import styles from './RailBilling.module.css';

type RailBillingFormProps = FormikProps<RailBillingForm> & {
	id: string;
};

/**
 * Form component for the Rail Billing Modal
 */
export default function SendRailBillingForm(props: RailBillingFormProps) {
	return (
		<Form
			id={props.id}
			className={styles.form}
		>
			<Field
				type='email'
				name='emailAddr'
				label='Email Address'
				placeholder='test@email.com'
				component={FormikTextInput}
			/>

			<Field
				name='emailSubject'
				label='Subject'
				component={FormikTextInput}
			/>

			<Field
				name='emailBody'
				label='Message'
				component={FormikTextInput}
				textArea
				rows={16}
			/>
		</Form>
	);
}
